<div class="start" *transloco="let t; read:'permit.workplace.start'">
    <pmt-workplace-recent></pmt-workplace-recent>
    <div *ngIf="(canCreateBaseOrDemoPermits$ | async) === true">
        <hr class="start__divider">
    </div>

    <button *ngIf="(isPremium$ | async) === true" [disabled]="!(isPremiumIssuer$ | async) && !(isPremiumSuperintendent$ | async)" [class.start__button--disabled]="!(isPremiumIssuer$ | async) && !(isPremiumSuperintendent$ | async)" class="start__button start__button--show-my-workplaces" (click)="premium()">
        {{ t("showMyWorkplaces")}}
    </button>

    <button *ngIf="(isPremium$ | async) === false && (canCreateBaseOrDemoPermits$ | async) === true" class="start__button start__button--create-new" (click)="basePermit()">
        {{ t("buttonCreateNew") }}
    </button>

    <div class="start__noUserRights" *ngIf="(canCreateBaseOrDemoPermits$ | async) === false && (isPremiumIssuer$ | async) === false && (isPremiumSuperintendent$ | async) === false">
        {{ t("noUserRights") }}
    </div>

    <div class="start__actions">
        <button class="start__actions__back" type="button" (click)="goBack()">{{ t("back") }}</button>
    </div>
</div>
